import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbLink } from "abreact/misc/AbLink";
import { reactRouteRenderContext } from "absdk/preliminary/commons/app/router/AbRouteRender";
import { LogUtils } from "abweb/utils/log/LogUtils";
import * as React from "react";
const LOG = LogUtils.getLogger(__filename);
/**
 * Render the route-based link for a given concrete route.
 * By default, if the user is not authorized (according to concreteRoute.isAuthorized()),
 * it skips rendering the link (returns null), and logs a corresponding warning. This can be overcome with showEvenIfUnauthorized
 *
 * For authorized routes, if the user clicks the link, the registered route's 'goto' will render route in
 * specified routeRenderContext within the current browser tab, and respect the addCurrentRouteToBrowserHistory
 * (applicable for mainArea routeRenderContext).
 * If the user ctrl-clicks the link, it will open the link (aka href) in a new browser tab specified by the
 * concrete route target (defaults to current browser tab).
 */
export function AbRouteLink(props) {
  const currRRC = React.useContext(reactRouteRenderContext()); // useContext can not be conditionally invoked!
  const {
    concreteRoute,
    showEvenIfUnauthorized
  } = props;
  const isUnauthorized = !concreteRoute.isAuthorized();
  if (isUnauthorized && !showEvenIfUnauthorized) {
    LOG.info(`User is not authorized for route '${concreteRoute.href()}', skipping rendering of AbRouteLink.`);
    return null;
  }
  const addCurrentRouteToBrowserHistory = props.addCurrentRouteToBrowserHistory ?? true;
  // Prior to 3/4/25, concreteRoute goto and href members could be undefined - see 2/25/25 checkin if interested
  const linkProps = {
    onClick: event => {
      // noinspection JSIgnoredPromiseFromCall
      concreteRoute.goto(currRRC, addCurrentRouteToBrowserHistory);
      props.onClick?.(event);
    },
    href: concreteRoute.href(),
    target: concreteRoute.target // do not default to _self (default) to reduce noise
  };

  // Add 'ab-route-link' className to support possible future custom styling of the AbRouteLink output
  const className = ReactUtils.componentClassNamesString("ab-route-link", props);
  const tooltip = isUnauthorized ? AbReactResources.unauthorizedRouteView_message() : props.tooltip;
  return /*#__PURE__*/React.createElement(AbLink, _extends({}, props, {
    className: className
  }, linkProps, {
    disabled: props.disabled || isUnauthorized,
    tooltip: tooltip
  }));
}
//# sourceMappingURL=AbRouteLink.js.map
